import React, {useMemo} from "react";
import {userManager} from "../../managers/UserManager";
import {Device} from "./Device";
import {i18nFormat} from "../../lib/i18nFormat";
import {EmptyPageContent} from "../../components/EmptyPageContent";
import {deviceModels} from "../../enums/deviceModels";

export function DevicesPage() {
  const user = userManager.store(state => state.user); // User is updated on state change.

  const devicesArray = useMemo(() => {
    if (!user || !Array.isArray(user.homeys)) {
      return [];
    }
    const result = [];
    // Add add-ons from each Homey to the devices array after the parent Homey device.
    user.homeys.forEach((homey) => {
      // Only show devices for which the user has the "owner" role.
      if (homey.role !== "owner") {
        return;
      }
      // Add the Homey device itself only if it's a supported model. E.g. exclude Homey Self-Hosted Servers.
      if (Object.values(deviceModels).includes(homey.model)) {
        result.push({
          key: homey.id,
          device: homey,
          parent: null
        });
      }
      if (Array.isArray(homey.bridges)) {
        homey.bridges.forEach((bridge) => {
          result.push({
            key: `${bridge.mac}`,
            device: bridge,
            parent: homey
          });
        });
      }
    });
    return result;
  }, [user]);

  if (devicesArray.length === 0) {
    return (
      <EmptyPageContent
        glyph={"glyph-system-devices"}
        title={i18nFormat("devices.no-devices.title")}
        text={i18nFormat("devices.no-devices.description")}
      />
    )
  }


  return (
    <section className="account-page account-devices">
      <header className="account-page__header">
        <h1 className="account-page__title">{i18nFormat("devices.title")}</h1>
        <p className="account-page__text">{i18nFormat("devices.subtitle")}</p>
      </header>
      <div className="account-page__content">
        {devicesArray.map((deviceObject) => (
          <Device key={deviceObject.key} device={deviceObject.device} parent={deviceObject.parent}/>
        ))}
      </div>
    </section>
  );
}